<template>
  <div>
    <textarea v-model="value" class="textarea"></textarea>
    <div class="is-flex mt-5 is-justify-content-space-evenly">
      <button @click="onSubmitClick" class="button is-info" style="width: 100px;">submit</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalTextarea',
  props: {
    onSubmit: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      value: ''
    }
  },
  methods: {
    onSubmitClick () {
      this.onSubmit(this.$attrs.payload.modal_id, this.value)
    }
  }
}
</script>
